export default function FormSection({ title, subtitle = null, children, className = "", compact = false }) {
  return (
    <div className={`${compact ? "mb-4" : "mb-8"} ${className}`}>
      <div className={compact ? "flex items-center mb-2" : ""}>
        {title && <h3 className={`text-lg font-semibold ${compact && subtitle ? "mr-2" : "mb-2"}`}>{title}</h3>}
        {subtitle && compact && <p className="text-sm text-gray-600">{subtitle}</p>}
      </div>
      {subtitle && !compact && <p className="text-sm text-gray-600 mb-2">{subtitle}</p>}
      {children}
    </div>
  )
}

